import { flatten } from 'nav-utilities';

/**
 * There can be multiple sub-columns in a column.
 * This will flatten all links in those columns so they
 * can be iterated on deep in the menu.
 * @param column {NavMenu|NavMenuItem}
 * @returns {Array<NavMenuItem>}
 */
const getColumnChildren = column => {
  const children = flatten(column?.children);
  // Add the first link in the array if it has a label.
  // This is usually something like 'SHOES' or whatever.
  if (column.label) {
    children?.unshift(column);
  }
  return children;
};

/**
 * Template for desktop menu dropdown column
 * @param {Object} column
 * @returns {Array<NavMenuItem>}
 */
export const columnChildren = column => {
  const columnChildren = getColumnChildren(column).filter(
    link => link?.label && link.flags.hideFromDesktop !== true,
  );
  if (!columnChildren?.length) {
    return null;
  }
  return columnChildren;
};
